import { trpc } from "@blis/trpc/react";

export function useSettings(suspense = false) {
  const { data, isLoading } = trpc.settings.list.useQuery(undefined, {
    suspense,
    staleTime: 1000 * 60 * 60,
  });

  return { settings: data || {}, fetching: isLoading };
}

export function useFeatureFlags() {
  const { data, isLoading } = trpc.settings.featureFlags.useQuery();

  return { featureFlags: data, fetching: isLoading };
}
